<template>
  <div>
    <headNav></headNav>
    <div  style="height: 50px;"></div>
    <div>
      <img src="../assets/wdjf.jpg" class="img-responsive" />
    </div>



    <div class="container" style="margin-top: 24px;">
      <div class="row">
        <div class="col-md-3 visible-lg-block visible-md-block">

          <div style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/publicHead.png" class="img-responsive" />
          </div>
          <div style="width: 100%;" class="btn-group-vertical " role="group">
            <router-link to="/dszzc"><button type="button" class="btn btn-default btn-block">董事长致辞</button></router-link>
            <router-link to="/gsjj"><button type="button" class="btn btn-default btn-block">公司简介</button></router-link>
            <button type="button" class="btn btn-primary btn-block">威盾技防</button>
            <router-link to="/fwfw"> <button type="button" class="btn btn-default btn-block">服务范围</button></router-link>
            <router-link to="/xmzs"><button type="button" class="btn btn-default btn-block">项目展示</button></router-link>
            <router-link to="/wdtb"><button type="button" class="btn btn-default btn-block">威盾特保</button></router-link>
            <router-link to="/xwdt"><button type="button" class="btn btn-default btn-block">新闻动态</button></router-link>
            <router-link to="/bzzl"><button type="button" class="btn btn-default btn-block">报纸专栏</button></router-link>
            <router-link to="/hyxw"><button type="button" class="btn btn-default btn-block">行业新闻</button></router-link>
          </div>
          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/hezuo.png" class="img-responsive" />
          </div>

        </div>
        <div class="col-md-9 text-left">
          <h2 style="font-weight: bold;margin-top: 0px;">威盾技防</h2>
          <span>威盾官网 2021-11-16</span>
          <div style="text-indent: 2em;margin-top: 10px;">
          <span class="span16">河南威盾安防服务有限公司 是总公司旗下的一家专注与安防监控类产品的研发、生产、销售及提供行业完整解决方案的企业。 服务于政府、公安、智能交通、金融、通信、能源、教育、旅游、社区、医疗、林业、机场、港口码头、小区等众多信息化建设领域，覆盖 平安校园 、 平安农村 、 平安城市 等领域。最近他们刚刚完成了郑州海关保税区的安防设计、安装、调控工作。</span>
          <img class="img-responsive" src="../assets/wdjf_one.jpg">
          <img  style="margin-bottom: 10px;" class="img-responsive" src="../assets/wdjf_two.jpg">
          <span class="span16">经营范围 包括安防工程、摄录器材的施工及售后服务；电线电缆的生产及销售；计算机软件开发、计算机系统集成、计算机网络工程施工、建筑智能化工程施工。</span>
          </div>
        </div>
      </div>
    </div>
     <Base></Base>
  </div>

</template>

<script>
  $(function() {

  });

  export default {
    data() {
      return {

      }
    },
    methods: {}




  }
</script>

<style>
  .btn-block {
    border-radius: 0px;
    height: 49px;
  }
.row{
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/wdjf.vue